module.exports = __webpack_public_path__ + "img/bg-1.430bb167.png";